import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import ClassifiersList from './ClassifiersList.tsx';

const ClassifiersPage = () => {
    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <ClassifiersList />
            </div>
        </PaddedLayout>
    );
};

export default ClassifiersPage;
